import { AxiosRequestConfig } from 'axios'
import { useMutator as useOrvalMutator } from '@dhl/receiver-axios'

export const baseUrl = '/address-format-api'

export const useMutator = <T>(): ((config: AxiosRequestConfig) => Promise<T>) => useOrvalMutator(baseUrl)
